<script setup lang="ts">
import { onBeforeMount, onMounted, onUnmounted, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { useSurveyStore } from '@/stores/survey';
import SurveyResponse from '@/components/survey/SurveyResponse.vue';

const surveyStore = useSurveyStore();
const { error, isValidationError, isColorsSwitchEnabled } =
	storeToRefs(surveyStore);

const onResize = (): void => {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);

	window.addEventListener('resize', () => {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	});
};

onBeforeMount(async () => {
	await surveyStore.init();

	if (isColorsSwitchEnabled.value) {
		surveyStore.checkInitialTheme();
		surveyStore.listenToAppTheme();
	}
});

onMounted(() => {
	nextTick(() => {
		window.addEventListener('resize', onResize);
	});
	onResize();
});

onUnmounted(() => {
	window.removeEventListener('resize', onResize);
	if (isColorsSwitchEnabled.value) {
		surveyStore.stopListening();
	}
});
</script>

<template>
	<div class="app-layout">
		<SurveyResponse v-if="error && !isValidationError" />
		<RouterView v-else class="app-content" />
	</div>
</template>

<style lang="scss">
.app-layout {
	display: flex;
	flex-direction: column;
	min-height: 100vh; // fallback
	min-height: calc(var(--vh, 1vh) * 100);

	.app-content {
		display: flex;
		flex-direction: column;
		flex: 1 0 auto;
	}
}
</style>
